import { paginationStyle } from './shared-styles-from-theme-fluent';

export const productGroupsStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets', largeSize }) => ({
  '#button-chart-toggle': {
    '&.hidden': {
      display: 'none',
    },
  },
  '#product-groups-toolbar-divider': {
    '&.hidden': {
      display: 'none',
    },
  },
  '.table-container table.table tbody': {
    'overflow-wrap': 'break-word',
    '& tr td': {
      '& span': {
        'word-break': 'break-word',
      },
      '& a': {
        'word-break': 'break-word',
      },
    },
  },
  '.popover-edit-bid': {
    '&>span': {
      display: 'block',
      marginBottom: 16,
    },
    '& .bidWarning': {
      marginBottom: 10,
      maxWidth: 291,
    },
  },
  '.grid-popupeditor .grid-error-list': {
    padding: 0,
  },
  '.grid-bid-warning': {
    '& .iconba-Warning': {
      marginRight: 5,
      color: '#D83B01',
    },
    '& .warning-count': {
      color: '#D83B01',
    },
  },
  '.product-group-popover-warning.popover-view': {
    padding: 15,
    '& .iconba.iconba-Cancel': {
      fontSize: 14,
      opacity: 1,
    },
    '& .popover-titled-content__title': {
      color: '#D83B01',
      '& .status_warning.iconba.iconba-Warning': {
        marginRight: 5,
      },
    },
    '& .popover-titled-content__body': {
      '& .seperator': {
        marginLeft: 5,
        marginRight: 5,
      },
    },
  },
  'span.clickable.toggle-row.grid-expandable:before': {
    content: '"\\F08F"',
  },
  'span.clickable.toggle-row.grid-expanded:before': {
    content: '"\\F08E"',
  },
  'span.productgroup-row-icon.clickable.show-product-selector': {
    'font-family': iconFontFamily,
  },
  'span.productgroup-row-icon.clickable.show-product-selector.add_icon:before': {
    content: '"\\E948"',
  },
  'span.productgroup-row-icon.clickable.show-product-selector.grid-edit-icon:before': {
    content: '"\\E70F"',
  },
  'nav li.toggle-button-disabled #button-chart-toggle': {
    cursor: 'not-allowed',
  },
  '.table-page-container': {
    '& .grid-column-DestinationUrl .grid-cell-text': {
      wordBreak: 'break-all',
    },
    '& .grid-column-DestinationUrl .grid-editable-cell-container': {
      alignItems: 'center',
    },
    '& .scope-navigator': {
      wordBreak: 'break-all',
    },
    '& .flatten-path': {
      fontFamily: 'Segoe UI',
      fontSize: '12px',
      lineHeight: '24px',
      alignItems: 'center',
      color: '#605E5C',
    },
    '& .view-switch-button': {
      background: palette.white,
      color: palette.themePrimary,
      borderRadius: '0px 2px 2px 0px',
      padding: '0px',
      width: 32,
      minWidth: 32,
      minHeight: 32,
      height: 32,
    },
    '& .view-switch-button.active': {
      background: palette.themePrimary,
      border: '0px',
      borderRadius: '2px 0px 0px 2px',
      '& .iconba': {
        color: palette.white,
      },
    },
    '& .view-switch-button.not-allowed': {
      cursor: 'not-allowed',
    },
    '& .toolbar-container': {
      '& .add-filter-button': {
        paddingLeft: 0,
        marginLeft: 0,
      },
    },
  },
  '.product-groups-page-list': {
    display: 'flex',
    '& .view-switch-button': {
      borderRadius: '2px 0px 0px 2px',
    },
    '& .view-switch-button.active': {
      borderRadius: '0px 2px 2px 0px',
    },
  },
  '.product-groups-page-list-hide': {
    display: 'none',
  },
  '.product-groups-page-hierarchy': {
    display: 'flex',
  },
  '.product-groups-page-hierarchy-hide': {
    display: 'none',
  },
  '.table-container table.table': {
    '& tbody tr td:nth-child(2)': {
      borderRight: '1px solid #EDEBE9 !important',
    },
    '& thead.header tr th:nth-child(2)': {
      borderRight: '1px solid #EDEBE9 !important',
    },
    '& span.clickable.toggle-row': {
      '&.grid-expanded, &.grid-expandable': {
        float: 'left',
        marginRight: 5,
        marginTop: 3,
      },
    },
    '& tbody tr td > div.grid-editable-cell-container': {
      display: 'flex',
      justifyContent: 'flex-end !important',
    },
    '.product-condition-cell .productgroup-icon-container': {
      float: 'right',
    },
  },
  '.product-group-popover-details': {
    '& button.closeimage': {
      right: 10,
      top: 10,
      color: '#605e5c',
      position: 'absolute',
    },
    '& .closeimage:before': {
      fontFamily: iconFontFamily,
      content: '"\\E711"',
    },
  },
  '.popover-view__content': {
    background: '#fff',
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: 'normal',
    '& .productgroup-detail': {
      margin: '13px 28px 17px 28px',
      '& .partition-trail': {
        fontSize: '12px',
        lineHeight: '24px',
        display: 'flex',
        alignItems: 'center',
        color: '#605E5C',
      },
      '& .current-attribute': {
        fontWeight: 600,
        fontSize: '20px',
        lineHeight: '28px',
        color: '#323130',
      },
      '& .product-sample-description': {
        fontSize: '12px',
        lineHeight: '22px',
        color: '#323130',
      },
      '& .view-full-product': {
        marginTop: 15,
        '& > a': {
          fontSize: '14px',
          lineHeight: '19px',
          color: '#0078D4',
        },
      },
      '& .product-sample-id': {
        fontWeight: 600,
        fontSize: 14,
      },
      '& .product-sample-title': {
        fontSize: 14,
      },
    },
  },
  '.blocker-container': {
    '& .blocker': {
      zIndex: 100002,
      [`@media (max-width: ${largeSize}px)`]: {
        left: '228px !important',
      },
    },
  },
  // for DoubleListBox
  '#productgroups-subdivider': {

    '& .panel-footer': {
      backgroundColor: 'white',
      borderTop: '0px',

      '& .cancel-button': {
        marginLeft: 10,
      },
    },

    '& .row': {
      margin: 0,
    },

    '& .col-sm-12': {
      padding: 0,
    },

    '& .panel-heading': {
      fontWeight: 'normal',
    },

    '& .form-control': {
      minWidth: 180,
      width: 'fit-content',
    },

    '& .doubleListBox': {

      '& .selector-column-header': {
        float: 'right',
        width: 80,
        textAlign: 'right',
      },
      '& .selector-column-header-last': {
        float: 'right',
        width: 80,
        textAlign: 'right',
        marginRight: 30,
      },
      '& .selector-column-value': {
        float: 'right',
        width: 80,
        textAlign: 'right',
      },
      '& .selector-column-value-last': {
        float: 'right',
        width: 80,
        textAlign: 'right',
        marginRight: 30,
      },

      '& .dlb-filter-alignPlaceholder': {
        width: 608,

        '& .searchbox-input': {
          paddingLeft: 48,
          height: 48,
          width: '100%',
        },

        '& .form-control-feedback': {
          left: 0,
          lineHeight: '48px',
          height: 48,
          marginLeft: 16,
          position: 'absolute',
          width: 'fit-content',
        },
      },

      '& .layout-columns-element': {
        boxSizing: 'border-box',
        padding: 0,

        '& ~ .layout-columns-element': {
          paddingLeft: 7.5,
        },

        '& .panel-form': {
          border: [1, 'solid', '#BBB'],
          boxShadow: 'none',
          padding: 0,

          '& .panel-heading': {
            backgroundColor: `${palette.white}`,
            border: 'none',
            padding: '0 8px',

            '& .panel-title': {
              fontWeight: 600,
            },
          },

          '& .panel-body': {
            padding: 0,

            '& .custom-values': {
              height: 200,
              width: '100%',
            },

            '& .add-custom-button': {
              margin: '10px 8px',
              float: 'right',
            },

            '& .dlb-source-summary': {
              padding: '0 8px',
            },

            '& .dlb-selectAll, .dlb-deselectAll': {
              color: `${palette.themePrimary}`,
              padding: '0 10px',
              right: 8,
              zIndex: 1,

              '& .arrow-button': {
                display: 'none',
              },
            },

            '& .dlb-source, & .dlb-selected': {
              height: 228,
              overflowX: 'auto',
              overflowY: 'auto',

              '& .dlbItem': {
                minHeight: 28,
                position: 'relative',
                padding: '0 8px',

                '& .glyphicon-triangle-right, & .glyphicon-triangle-bottom': {
                  marginRight: 5,
                },

                '& .dlbItem-actions': {
                  position: 'absolute',
                  right: 8,
                  top: 5,
                  '& .arrow-button.enabled:before': {
                    fontFamily: iconFontFamily,
                    content: '"\\E710"',
                  },

                  '& .arrow-button.disabled:before': {
                    content: '""',
                  },
                  '& .arrow-button.remove:before': {
                    fontFamily: iconFontFamily,
                    content: '"\\E738"',
                  },
                },

                '& .dlbItem-content': {
                  minHeight: 28,
                  padding: '4px 0',

                  '& table': {
                    width: 510,

                    '& .tree-indent': {
                      paddingLeft: 10,
                    },
                  },

                  '& table > tbody > tr > td:nth-child(1)': {
                    textAlign: 'left',
                    width: 'auto',
                  },
                  '& table > tbody > tr > td:nth-child(2)': {
                    textAlign: 'right',
                    width: 120,
                  },

                  '& span': {
                    wordBreak: 'break-all',
                  },
                },
              },
            },

            '& ::-webkit-scrollbar':
            {
              width: 4,
              backgroundColor: 'transparent',
            },

            '& ::-webkit-scrollbar-track':
            {
              backgroundColor: 'transparent',
            },

            '& ::-webkit-scrollbar-thumb':
            {
              width: 4,
              height: 44,
              backgroundColor: '#EBEAE8',
            },

            '& ::-webkit-scrollbar:horizontal':
            {
              height: 4,
              backgroundColor: 'transparent',
            },

            '& ::-webkit-scrollbar-track:horizontal':
            {
              backgroundColor: 'transparent',
            },

            '& ::-webkit-scrollbar-thumb:horizontal':
            {
              width: 200,
              height: 4,
              backgroundColor: '#EBEAE8',
            },
          },
        },
      },

      '& .dlb-pager-container': {
        width: 'fit-content',
        float: 'right',
        marginTop: 8,

        '& .pager': {
          height: 'auto',
        },
      },
    },
    ...paginationStyle({ palette, iconFontFamily }),
  },
  '.gotoCampaignSettings': {
    textDecoration: 'underline',
  },
});
